// removed by extract-text-webpack-plugin
module.exports = {"root":"IconSocialMediaTwitter__root__38V5t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconSocialMediaTwitter/IconSocialMediaTwitter.css
// module id = 1854
// module chunks = 0